export const onLoad = (cb: () => void): void => {
	if (document.readyState === 'complete') {
		cb();
	} else {
		window.addEventListener('load', cb);
	}
};
